export const paths = {
  ROOT: '/',
  UNAUTHORIZED: '/unauthorized',
  EVENT_REGISTRATION: '/organizations/:organizationId/opportunities/:eventId/event-registration/:token?',
  EVENT_DETAILS: '/organizations/:organizationId/activities/:eventId',
  EVENT_STABLE_LINK: '/organizations/:organizationId/event_links/:stableLinkCode',
  STABLE_LINK_REGISTRATION: '/organizations/:organizationId/event_links/:stableLinkCode/registration',
  SUPER_EVENT: '/organizations/:organizationId/pages/:stableLinkCode',
  MY_EVENTS_LIST: '/organizations/:organizationId/my/activities',
  TOKEN_LOGIN: '/organizations/:organizationId/token/:token',
  TOKEN_LOGIN_REGISTER: '/organizations/:organizationId/opportunity-id/:opportunityId/token/:token',
  CALENDAR: '/organizations/:organizationId/calendar/:viewType?',
  ALL_EVENTS: '/organizations/:organizationId/all-events',
  OPPORTUNITIES: '/organizations/:organizationId/opportunities',
  OPPORTUNITY_DETAILS: '/organizations/:organizationId/opportunities/:eventId',
}
